import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-salary-slips',
  templateUrl: './psa-salary-slips.component.html',
  styleUrls: ['./psa-salary-slips.component.css']
})
export class PsaSalarySlipsComponent implements OnInit {
  title="Salary Slips Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-salary-slips/psa-salary-slips.component.ts